import { DrawLineStringMode, ModifyMode, ViewMode } from "@deck.gl-community/editable-layers";
import { PermitDecreeType, TemporaryDecreeType } from "@/types/decree.type";

import { RestrictionModeType } from "@/modules/restriction/components/map-tool-box/restriction-tool-box-entry.const";
import { RestrictionType } from "@/types/gql/graphql";
import { trafficRestrictionType } from "types";

type RestrictionModeConstructor = typeof ViewMode | typeof DrawLineStringMode | typeof ModifyMode;

export const trafficRestrictionTypeList = Object.entries(trafficRestrictionType).map(([key, value]) => ({
  value: key as keyof typeof trafficRestrictionType,
  label: value,
}));

export const temporaryDecreeTypes = Object.entries(TemporaryDecreeType).map(([key, value]) => ({
  value: key,
  label: value,
}));

export const permitDecreeTypes = Object.entries(PermitDecreeType).map(([key, value]) => ({
  value: key,
  label: value,
}));

export const isTrafficRestriction = (type?: RestrictionType | null) => {
  if (!type) {
    return false;
  }
  return Object.keys(trafficRestrictionType).includes(type);
};

export const restrictionCursorCell: RestrictionModeType[] = [
  RestrictionModeType.AddCurbZoneRestriction,
  RestrictionModeType.AddTrafficRestriction,
  RestrictionModeType.AddPermitLocation,
];

/** Different GeoJsonEditModes depending on app mode */
export const restrictionGeoJsonLayerModes: Record<RestrictionModeType, RestrictionModeConstructor> = {
  [RestrictionModeType.View]: ViewMode,
  [RestrictionModeType.AddCurbZoneRestriction]: DrawLineStringMode,
  [RestrictionModeType.MultiCreateCurbZoneRestriction]: ModifyMode,
  [RestrictionModeType.MultiEditRestriction]: ModifyMode,
  [RestrictionModeType.EditCurbZoneRestriction]: ModifyMode,
  [RestrictionModeType.AddTrafficRestriction]: DrawLineStringMode,
  [RestrictionModeType.EditTrafficRestriction]: ModifyMode,
  [RestrictionModeType.AddPermitLocation]: DrawLineStringMode,
  [RestrictionModeType.EditPermitLocation]: ModifyMode,
};
